<template>
  <div id="app" class="app" @click.capture="handleServiceLinkClick">
    <website-top-login-bar v-if="topCompanyLoginEnabled && !isServiceSection" />
    <div class="main-content" v-for="item in visibleShellModuleList" :key="item.moduleCode">
      <web-satus-header
        v-if="item.moduleCode === 'headerInformation'"
        :HeaderStatusHtmlText="headerStatusHtmlText"
      />
      <header-background
        v-else-if="item.moduleCode === 'headerBackground'"
        :HeaderHtmlText="headerHtmlText"
      />
      <component
        v-else-if="isIntegratedService || (currentLayout === 'LayoutWithoutMenu' && $route.path !== '/public/service/login')"
        :is="getComponentName(item.moduleCode)"
        :module-data="item"
        :style="getModuleStyle(item)"
      />
    </div>
    <nav v-if="isIntegratedService" class="service-location" aria-label="服务平台位置">
      <router-link class="service-home-link" to="/home">
        <i class="el-icon-back" aria-hidden="true"></i>
        返回官网
      </router-link>
      <span class="service-location-title">服务平台</span>
    </nav>
    <!-- 根据当前路由的布局设置显示对应布局 -->
    <component :is="currentLayout" :key="currentLayout">
      <!-- 移除这里的 router-view，让布局组件自己处理 -->
    </component>
    <operation-guide-fab v-if="operationGuideEntryVisible" />
    <web-bottom v-if="bottomHtmlText" :bottomHtmlText="bottomHtmlText" />
  </div>
</template>

<script>
const defaultLayout = 'LayoutWithoutMenu'
import LayoutWithMenu from '@/views/layouts/LayoutWithMenu.vue'
import LayoutWithoutMenu from '@/views/layouts/LayoutWithoutMenu.vue'
import { getTemplateDetail } from '@/api/common'
import { mapGetters, mapState } from "vuex";
import Cache from '@/utils/cache.js'
import headerBackground  from '@/components/WebHeader.vue'
import WebBottom from '@/components/WebBottom.vue'
import WebSatusHeader from '@/components/WebSatusHeader.vue'
import OperationGuideFab from '@/components/OperationGuide/OperationGuideFab.vue'
import store from './store';
import { commonMixin } from "@/mixins/analysisMixin.js";
import { detailSetting } from '@/api/common'
import WebsiteTopLoginBar from '@/components/WebsiteTopLoginBar.vue'

export default {
  mixins: [commonMixin],
  data() {
    return {
      // 移除本地数据，改用 Vuex 状态
    }
  },
  components: {
    WebsiteTopLoginBar,
    LayoutWithoutMenu,
    LayoutWithMenu,
    headerBackground,
    WebBottom,
    WebSatusHeader,
    OperationGuideFab,
    DesktopNavModule: () => import("@/components/desktop-nav-module/desktop-nav-module.vue"),
    AutoNotificationModule: () => import("@/views/components/auto-notification-module/auto-notification-module.vue"),
    InfomationModule: () => import("@/views/components/infomation-module/infomation-module.vue"),
    ImageCarouselModule: () => import("@/views/components/image-carousel-module/image-carousel-module.vue"),
    QuickEntryModule: () => import("@/views/components/quick-entry-module/quick-entry-module.vue"),
    CooperativePartnerModule: () => import("@/views/components/cooperative-partner-module/cooperative-partner-module.vue"),
    GroupModule: () => import("@/views/components/groupModule/groupModule"),
    ThirdLinkModule: () => import("@/views/components/third-link-module/third-link-module.vue"),
    ThirdShowModule: () => import("@/views/components/third-show-module/third-show-module.vue"),
    GlobalSuspendedWindow: () => import("@/views/components/global-suspended-window/global-suspended-window.vue"),
    middleBackgroundModule: () => import("@/views/components/middle-background-module/middle-background-module.vue"),
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters('template', ['getModuleByCode', 'topCompanyLoginEnabled', 'operationGuideEntryReady', 'operationGuideWebsiteEnabled', 'operationGuideServicePlatformEnabled']),
    
    ...mapState({
      bottomHtmlText: state => state.template.bottomHtmlText,
      headerHtmlText: state => state.template.headerHtmlText,
      headerStatusHtmlText: state => state.template.headerStatusHtmlText
    }),
    isServiceSection() {
      return this.$route.matched.some(record => record.meta.section === 'service')
    },
    operationGuideEntryVisible() {
      // 未取得成功配置前不挂载入口，也不发送指引和问答能力请求。
      if (!this.operationGuideEntryReady || /^\/public\/service\/login/.test(this.$route.path)) return false
      return this.isServiceSection ? this.operationGuideServicePlatformEnabled : this.operationGuideWebsiteEnabled
    },
    isIntegratedService() {
      return this.serviceIntegrationEnabled && this.isServiceSection
    },
    shellModuleList() {
      if (!this.isIntegratedService) return this.globalModuleList
      // 服务平台只保留公共头部和导航，不展示官网首页的宣传模块。
      // 导航在部分模板中并未配置 isFixed，仍需在服务区域展示。
      const modules = this.templateData?.resultData?.moduleComponentList || []
      return modules
        .filter(item => ['headerInformation', 'headerBackground', 'desktopNavModule'].includes(item.moduleCode))
        .slice()
        .sort((a, b) => (a.orderId || 0) - (b.orderId || 0))
    },
    visibleShellModuleList() {
      return this.shellModuleList.filter(item => {
        if (item.moduleCode === 'headerInformation') return !!this.headerStatusHtmlText
        if (item.moduleCode === 'headerBackground') return !!this.headerHtmlText
        return true
      })
    },
    currentLayout() {
      // 优先查找当前路由的 meta.layout
      let layout = this.$route.meta.layout;

      // 如果当前路由没有设置 layout，则向上查找父路由的 layout
      if (!layout) {
        const matchedRoute = this.$route.matched.find(r => r.meta && r.meta.layout);
        layout = matchedRoute ? matchedRoute.meta.layout : null;
      }

      console.log(layout, 'layoutlayout');
      return layout ? `Layout${layout.charAt(0).toUpperCase() + layout.slice(1)}` : defaultLayout
    },
    // 使用 getter 获取 desktopNavModule 模块数据
    desktopNavModule() {
      return this.getModuleByCode('desktopNavModule') || { componentList: [] };
    }
  },
  methods: {
    handleServiceLinkClick(event) {
      // 兼容接口配置的 HTML 链接；保留用户主动使用快捷键打开新标签的行为。
      if (event.defaultPrevented || event.button !== 0 ||
          event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
      const element = event.target instanceof Element ? event.target : event.target?.parentElement
      const link = element?.closest('a[href]')
      if (!link || link.hasAttribute('download')) return
      if (this.goToService(link.getAttribute('href'))) {
        event.preventDefault()
        event.stopPropagation()
      }
    },
    // 获得标签配置 - 这个方法可能处理多种配置，不只是标题
    detailSetting() {
      detailSetting({cfgGroup:'WEB_SITE_TAG'}).then((res) => {
        if (res.resultData) {
          let metaList = JSON.parse(res.resultData)
          metaList.forEach(item => {
            document.head.insertAdjacentHTML('beforeend', item);
          })
        }
      })
    },
    /**
     * 获取模块样式
     */
    getModuleStyle(module) {
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);

        if (moduleStyle && moduleStyle.options) {
          style = {
            ...moduleStyle.options,
          }

          // 检查是否为移动端，如果是则清除左右边距和内边距
          const isMobile = window.innerWidth <= 768;
          if (isMobile) {
            // 清除移动端的左右边距和内边距
            delete style.marginLeft;
            delete style.marginRight;
            delete style.paddingLeft;
            delete style.paddingRight;

            // 确保宽度为100%
            style.width = '100%';
            style.boxSizing = 'border-box';
          } else {
            // 桌面端保持原有逻辑
            if (style.paddingLeft || style.marginLeft) {
              style.width = 'auto';
              style.boxSizing = 'border-box';
              style.marginRight = style.marginRight || '0';
            } else if (style.width === '100%') {
              style.width = '100%';
              style.boxSizing = 'border-box';
            }
          }
        }
        return style;
      } catch (e) {
        console.warn(`解析模块 ${module.moduleName} 样式失败:${module}`,e );
        return {};
      }
    },
    getTitleStyle(module) { 
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);
        if (moduleStyle && moduleStyle.titleStyle) {
          style = {
            ...moduleStyle.titleStyle,
          }
        }
        return style;
      } catch (e) {
        return {};
      }
    },

    getContentStyle(module) { 
      try {
        let style = {}
        const moduleStyle = JSON.parse(module.moduleStyleData);
        if (moduleStyle && moduleStyle.titleStyle) {
          style = {
            ...moduleStyle.titleStyle,
          }
        }
        return style;
      } catch (e) {
        return {};
      }
    },
        shouldShowModule(module) {
            try {
                if (!module) return false;
                const moduleStyle = module.moduleStyleData ? JSON.parse(module.moduleStyleData) : null;
                if (module.moduleCode === 'ImageCarouselModule') {
                    console.log(module, moduleStyle, 'moduleStylemoduleStylemoduleStylemoduleStyle')
                }
                if (moduleStyle && typeof moduleStyle.isFixed !== 'undefined') {
                    return !!moduleStyle.isFixed;
                }
                return module.isShow === 1 || module.isShow === true;
            } catch (e) {
                return module && (module.isShow === 1 || module.isShow === true);
            }
        },
    getTemplateDetail() {
      getTemplateDetail({id: 1}).then(res => {
        // 将数据存储到 Vuex
        this.$store.dispatch('template/setTemplateData', res);
      })
    },
    
    // 初始化SEO设置
    initSEO() {
      // 初始化站点信息
      // 初始化站点信息
      this.$store.dispatch('seo/initSiteInfo').then(() => {
        // 路由切换时更新SEO
        this.$router.afterEach((to) => {
          this.updatePageSEO(to);
        });
        
        // 初始加载时也要更新SEO
        this.updatePageSEO(this.$router.currentRoute);
      });
    },
    updatePageSEO(route) {
      // 获取当前路由的SEO配置
      const routeSEO = route.meta.seo || {};
      
      // 获取站点默认SEO信息
      const siteName = this.$store.getters['seo/siteName'];
      const siteDescription = this.$store.getters['seo/siteDescription'];
      const siteKeywords = this.$store.getters['seo/siteKeywords'];
      
      // 合并页面SEO和站点SEO
      const pageTitle = routeSEO.title ? `${routeSEO.title} - ${siteName}` : siteName;
      const pageDescription = routeSEO.description || siteDescription;
      const pageKeywords = routeSEO.keywords || siteKeywords;
      
      // 更新页面标题
      document.title = pageTitle;
      
      // 更新meta标签
      this.updateMetaTag('description', pageDescription);
      this.updateMetaTag('keywords', pageKeywords);
      
      // 如果有其他meta标签，也可以在这里更新
      if (routeSEO.ogTitle) {
        this.updateMetaTag('og:title', routeSEO.ogTitle, 'property');
      }
      if (routeSEO.ogDescription) {
        this.updateMetaTag('og:description', routeSEO.ogDescription, 'property');
      }
      if (routeSEO.ogImage) {
        this.updateMetaTag('og:image', routeSEO.ogImage, 'property');
      }
    },
    
    updateMetaTag(name, content, attribute = 'name') {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    }
  },
  mounted() {
    this.initSEO(); // 初始化SEO
    this.detailSetting()
    // 应用启动时检查并清除所有过期缓存
    store.dispatch('information/checkAndClearExpiredCache');

    // 定时检查并清除过期缓存（每30分钟执行一次）
    setInterval(() => {
      store.dispatch('information/checkAndClearExpiredCache');
    }, 1000 * 60 * 30);
    this.getTemplateDetail()
    if (!this.user && Cache.get('personUser')) {
      this.$store.dispatch("setUser", Cache.get('personUser'));
    }
    // 在App.vue中添加定时检查
    setInterval(() => {
      if (this.$store.state.user.token) {
        this.$store.dispatch('getMenuList') // 静默更新
      }
    }, 3600000 * 24) // 每小时检查一次
  },
}
</script>
<style lang="scss">
@import '@/assets/iconfont/iconfont.css';
</style>
<style>
body {
  margin: 0;
  padding: 0;
}
:root {
  --theme-GLOBAL_COLOR: #000; /* 默认为黑色 */
  --website-header-gutter: 100px;
}
@media (max-width: 1200px) {
  :root { --website-header-gutter: 6%; }
}
.app {
    position: relative;
}
.main-content {
    position: relative;
    height: 100%;
}
.service-location {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 70%;
  margin: 0 auto;
  padding: 18px 0 8px;
  box-sizing: border-box;
}
.service-home-link {
  color: #165DFF;
  text-decoration: none;
  padding: 8px 0;
}
.service-home-link:hover {
  text-decoration: underline;
}
.service-home-link:focus-visible {
  outline: 2px solid #165DFF;
  outline-offset: 4px;
}
.service-location-title {
  color: #333;
  font-weight: 600;
  padding-left: 16px;
  border-left: 1px solid #E4E4E4;
}
@media (max-width: 768px) {
  .service-location {
    width: 100%;
    padding: 12px 16px 4px;
  }
}
</style>
